import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import apiService from '../services/api';

const PropertyCard = ({ property }) => {
  const navigate = useNavigate();
  const { appId } = useParams();

  const handleCardClick = () => {
    const base = appId ? `/${appId}` : '';
    navigate(`${base}/property/${property.id}`);
  };

  const handleContactClick = (e) => {
    e.stopPropagation();
    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.openLink(`tel:${property.contact.phone}`);
    } else {
      window.open(`tel:${property.contact.phone}`, '_blank');
    }
  };

  const onImgError = (e) => {
    e.target.onerror = null;
    e.target.src = 'https://placehold.co/800x600/cccccc/969696.png?text=No+Image';
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer transition-transform hover:scale-105 hover:shadow-lg"
      onClick={handleCardClick}
    >
      <div className="relative">
        <img 
          src={property.images && property.images[0] ? property.images[0] : 'https://placehold.co/800x600/cccccc/969696.png?text=No+Image'} 
          alt={property.title}
          className="w-full h-48 object-cover"
          loading="lazy"
          onError={onImgError}
        />
        <div className="absolute top-2 left-2 bg-blue-600 text-white px-2 py-1 rounded text-sm font-medium">
          {apiService.getPropertyTypeLabel(property.type)}
        </div>
        <div className="absolute top-2 right-2 bg-black bg-opacity-50 text-white px-2 py-1 rounded text-sm">
          {property.rooms} комн.
        </div>
      </div>
      
      <div className="p-4">
        <h3 className="font-semibold text-lg text-gray-900 mb-2 line-clamp-2">
          {property.title}
        </h3>
        
        <div className="flex items-center text-gray-600 mb-2">
          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
          </svg>
          <span className="text-sm">{property.city}, {property.district}</span>
        </div>

        <div className="flex items-center justify-between mb-3">
          <div className="text-sm text-gray-600">
            <span>{property.area} м²</span>
            {property.floor && (
              <span className="ml-2">{property.floor}/{property.total_floors} эт.</span>
            )}
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-xl font-bold text-blue-600">
            {apiService.formatPrice(property.price, property.currency)}
          </div>
          <button 
            onClick={handleContactClick}
            className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm transition-colors"
          >
            Связаться
          </button>
        </div>

        <div className="mt-3 flex flex-wrap gap-1">
          {property.features.slice(0, 3).map((feature, index) => (
            <span 
              key={index}
              className="bg-gray-100 text-gray-700 px-2 py-1 rounded-full text-xs"
            >
              {feature}
            </span>
          ))}
          {property.features.length > 3 && (
            <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded-full text-xs">
              +{property.features.length - 3}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;